const BALMORAL_BROKERAGE_IDS = new Set(["1", "brokerage_balmoral_finance"]);
const BALMORAL_NAME_SNIPPETS = [
    "balmoral finance & advisory",
    "balmoral finance and advisory",
    "balmoral commercial finance",
];
const BALMORAL_EMAIL_DOMAINS = new Set(["balmoralcommercialfinance.com", "balmoralfinance.com"]);
const ENTERPRISE_BETA_ACCESS_PROFILE = "enterprise_beta";
const APP_SENSITIVE_LAUNCH_TOKEN_QUERY_PARAM = "launchToken";
const APP_SENSITIVE_LAUNCH_TOKEN_STORAGE_KEY = "financialEdge.appSensitiveLaunchToken";
const BETA_ALLOWED_TOOL_KEYS = new Set([
    "email-address-generator",
    "mini-engine",
    "bas-calculator",
    "lease-wale-calculator",
    "construction-feasibility",
    "servicing-calculator",
]);

function normalizeText(value) {
    return String(value || "")
        .trim()
        .toLowerCase();
}

function normalizeEmailDomain(value) {
    const normalizedEmail = normalizeText(value);
    const atIndex = normalizedEmail.lastIndexOf("@");

    if (atIndex === -1) {
        return "";
    }

    return normalizedEmail.slice(atIndex + 1);
}

function getBrowserSessionStorage() {
    try {
        return typeof window !== "undefined" ? window.sessionStorage : null;
    } catch (error) {
        return null;
    }
}

function readLaunchTokenFromLocation(location) {
    const searchParams = new URLSearchParams(location?.search || "");
    return String(searchParams.get(APP_SENSITIVE_LAUNCH_TOKEN_QUERY_PARAM) || "").trim();
}

export function getAppSensitiveLaunchToken(location = typeof window !== "undefined" ? window.location : null) {
    const tokenFromLocation = readLaunchTokenFromLocation(location);

    if (tokenFromLocation) {
        return tokenFromLocation;
    }

    return String(getBrowserSessionStorage()?.getItem(APP_SENSITIVE_LAUNCH_TOKEN_STORAGE_KEY) || "").trim();
}

export function captureAppSensitiveLaunchTokenFromLocation(location = typeof window !== "undefined" ? window.location : null) {
    const searchParams = new URLSearchParams(location?.search || "");
    const token = String(searchParams.get(APP_SENSITIVE_LAUNCH_TOKEN_QUERY_PARAM) || "").trim();

    if (!token) {
        return getAppSensitiveLaunchToken(location);
    }

    getBrowserSessionStorage()?.setItem(APP_SENSITIVE_LAUNCH_TOKEN_STORAGE_KEY, token);
    searchParams.delete(APP_SENSITIVE_LAUNCH_TOKEN_QUERY_PARAM);

    if (
        typeof window !== "undefined" &&
        location === window.location &&
        window.history?.replaceState
    ) {
        const nextSearch = searchParams.toString();
        const nextUrl = `${window.location.pathname}${nextSearch ? `?${nextSearch}` : ""}${window.location.hash || ""}`;
        window.history.replaceState(window.history.state, "", nextUrl);
    }

    return token;
}

export function createToolAccessContextFromLocation(location = window.location) {
    const searchParams = new URLSearchParams(location?.search || "");

    return {
        brokerageId:
            searchParams.get("_xctx") ||
            searchParams.get("brokerageId") ||
            searchParams.get("companyId") ||
            "",
        companyName:
            searchParams.get("companyName") ||
            searchParams.get("displayName") ||
            searchParams.get("company") ||
            "",
        email: searchParams.get("email") || searchParams.get("contactEmail") || "",
        betaAccessEnabled: searchParams.get("betaAccessEnabled") === "true",
        betaAccessProfile: normalizeText(searchParams.get("betaAccessProfile") || ""),
    };
}

export function isBalmoralToolAccessContext(context = {}) {
    if (BALMORAL_BROKERAGE_IDS.has(String(context?.brokerageId || "").trim())) {
        return true;
    }

    const normalizedCompanyName = normalizeText(context?.companyName);
    if (normalizedCompanyName && BALMORAL_NAME_SNIPPETS.some((snippet) => normalizedCompanyName.includes(snippet))) {
        return true;
    }

    return BALMORAL_EMAIL_DOMAINS.has(normalizeEmailDomain(context?.email));
}

export function canAccessInternalTool(tool, context = {}) {
    if (
        context?.betaAccessEnabled === true
        && context?.betaAccessProfile === ENTERPRISE_BETA_ACCESS_PROFILE
        && !BETA_ALLOWED_TOOL_KEYS.has(String(tool?.key || "").trim())
    ) {
        return false;
    }

    if (tool?.accessScope === "balmoral-only") {
        return isBalmoralToolAccessContext(context);
    }

    return true;
}
